import React from "react";
export function PromoBar() {
  return <div className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-130" data-mp="2sdgek435bzae">
      <div className="mx-auto flex max-w-5xl items-center justify-center px-4 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-131" data-mp="8aqgubtxvf2c">
        <p className="truncate text-cream" data-id="element-132" data-mp="3gm6dilgsowi">
          <span className="mr-1.5 font-bold tracking-wider text-gold" data-id="element-133" data-mp="3upjgxjwxef8p">LE PACK COMPLET</span>
          · 2 livres + 5 bonus · 27 $ US
        </p>
      </div>
    </div>;
}